import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import DatePickerModal from "../../../component/global/DatePicker";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";

export default function Personal({ data, editedDataHandler, spLoader }) {
    const [birthDate, setBirthDate] = useState({
        fa: data.birthday,
        en: "2000-01-01",
    });
    const [formData, setFormData] = useState({
        first_name: data.first_name,
        last_name: data.last_name,
        phone_number: data.phone_number,
        national_number: data.national_number,
        birthday: birthDate.fa,
        sex: data.sex,
        email: data.email,
    });
    const { t } = useTranslation();

    const onChangeHandler = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const [birthDatePicker, setBirthDatePicker] = useState(false);

    const [errors, setErrors] = useState({
        first_nameErr: "",
        last_nameErr: "",
        phone_numberErr: "",
        national_numberErr: "",
        sexErr: "",
        emailErr: "",
    });

    const handleFormErr = () => {
        let first_nameErr = "";
        let last_nameErr = "";
        let phone_numberErr = "";
        let national_numberErr = "";
        let sexErr = "";
        let emailErr = "";

        let patt = new RegExp(/^\?([0-9]*)$/);

        let mailPatt = new RegExp(
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        );

        if (formData.phone_number[0] === "+") {
            return formData.phone_number;
        } else if (formData.phone_number[0] === "0") {
            if (formData.phone_number[1] !== "9") {
                phone_numberErr = t(
                    "Src.Pages.UserPages.UserProfile.Personal.phone_numberErr1"
                );
            }
            if (formData.phone_number.length !== 11) {
                phone_numberErr = t(
                    "Src.Pages.UserPages.UserProfile.Personal.phone_numberErr1"
                );
            }
            formData.phone_number = "+98" + formData.phone_number.substr(1);
        }

        if (formData.first_name === "" || formData.first_name === null) {
            first_nameErr = t(
                "Src.Pages.UserPages.UserProfile.Personal. first_nameErr"
            );
        }
        if (formData.last_name === "" || formData.last_name === null) {
            last_nameErr = t(
                "Src.Pages.UserPages.UserProfile.Personal.last_nameErr"
            );
        }
        if (formData.phone_number === "" || formData.phone_number === null) {
            phone_numberErr = t(
                "Src.Pages.UserPages.UserProfile.Personal.phone_numberErr2"
            );
        }
        if (
            formData.national_number === "" ||
            formData.national_number === null
        ) {
            national_numberErr = t(
                "Src.Pages.UserPages.UserProfile.Personal.national_numberErr"
            );
        }
        if (formData.sex === "" || formData.sex === null) {
            sexErr = t("Src.Pages.UserPages.UserProfile.Personal.sexErr");
        }
        if (formData.email === "" || formData.email === null) {
            emailErr = t("Src.Pages.UserPages.UserProfile.Personal.emailErr1");
        }

        if (!mailPatt.test(formData.email)) {
            emailErr = t("Src.Pages.UserPages.UserProfile.Personal.emailErr2");
        }

        if (patt.test(formData.phone_number)) {
            phone_numberErr = t(
                "Src.Pages.UserPages.UserProfile.Personal.phone_numberErr1"
            );
        }

        setErrors({
            ...errors,
            first_nameErr,
            last_nameErr,
            phone_numberErr,
            national_numberErr,
            sexErr,
            emailErr,
        });

        if (
            first_nameErr === "" &&
            last_nameErr === "" &&
            phone_numberErr === "" &&
            national_numberErr === "" &&
            sexErr === "" &&
            emailErr === ""
        ) {
            return true;
        }

        return false;
    };

    const sendData = (e) => {
        e.preventDefault();

        let noErr = handleFormErr();

        if (!noErr) return false;

        editedDataHandler(e, formData);
    };

    useEffect(() => {
        setFormData({ ...formData, birthday: birthDate.fa });
    }, [birthDate]);

    return (
        <div className="page-load-fade">
            <form className="general-info-form">
                <Form.Group controlId="name">
                    <Form.Label>
                        {t("UserPanel.Profile.PersonalInfo.Name.Place.Holder")}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={formData.first_name}
                        name="first_name"
                        onChange={onChangeHandler}
                        className={errors.first_nameErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.first_nameErr ? "block" : "none",
                        }}
                    >
                        {errors.first_nameErr}
                    </div>
                </Form.Group>
                <Form.Group controlId="userLastName">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.PersonalInfo.LastName.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={formData.last_name}
                        name="last_name"
                        onChange={onChangeHandler}
                        className={errors.last_nameErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.last_nameErr ? "block" : "none",
                        }}
                    >
                        {errors.last_nameErr}
                    </div>
                </Form.Group>
                <Form.Group controlId="userCell" dir="rtl">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.PersonalInfo.PhoneNumber.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="tel"
                        value={formData.phone_number}
                        name="phone_number"
                        onChange={onChangeHandler}
                        className={errors.phone_numberErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.phone_numberErr ? "block" : "none",
                        }}
                    >
                        {errors.phone_numberErr}
                    </div>
                </Form.Group>
                <Form.Group controlId="userCode">
                    <Form.Label>
                        {t(
                            "UserPanel.Profile.PersonalInfo.NationalNumber.Place.Holder"
                        )}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        value={formData.national_number}
                        name="national_number"
                        onChange={onChangeHandler}
                        className={errors.national_numberErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.national_numberErr
                                ? "block"
                                : "none",
                        }}
                    >
                        {errors.national_numberErr}
                    </div>
                </Form.Group>
                <div>
                    <Form.Group controlId="formBasicBday">
                        <Form.Label>
                            {t(
                                "UserPanel.Profile.PersonalInfo.DateOfBirth.Place.Holder"
                            )}
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="مثال : نیما"
                            onChange={(e) => setBirthDate(e.target.value)}
                            value={birthDate.fa}
                            onClick={(e) => setBirthDatePicker(true)}
                            readOnly
                        />
                    </Form.Group>
                    <DatePickerModal
                        show={birthDatePicker}
                        close={setBirthDatePicker}
                        defaultValue={birthDate.fa}
                        onChange={setBirthDate}
                    />
                </div>
                <Form.Group controlId="formGender">
                    <Form.Label>
                        {t("UserPanel.Profile.PersonalInfo.Gender.Drop.Bar")}
                    </Form.Label>
                    <div>
                        <select
                            value={formData.sex}
                            name="sex"
                            id="gender"
                            className="add-user-select"
                            onChange={(e) =>
                                setFormData({
                                    ...formData,
                                    sex: e.target.value,
                                })
                            }
                        >
                            <option value="" disabled selected name="">
                                {t(
                                    "UserPanel.Profile.PersonalInfo.Gender.Drop.Select"
                                )}
                            </option>
                            <option value="1">
                                {t(
                                    "UserPanel.Profile.PersonalInfo.Gender.Male.Drop.Bar"
                                )}
                            </option>
                            <option value="2">
                                {t(
                                    "UserPanel.Profile.PersonalInfo.Gender.Female.Drop.Bar"
                                )}
                            </option>
                        </select>
                    </div>
                    <div
                        className="error"
                        style={{
                            display: errors.sexErr ? "block" : "none",
                        }}
                    >
                        {errors.sexErr}
                    </div>
                </Form.Group>
                <Form.Group controlId="userEmail">
                    <Form.Label>
                        {t("UserPanel.Profile.PersonalInfo.Email.Place.Holder")}
                    </Form.Label>
                    <Form.Control
                        type="email"
                        value={formData.email}
                        name="email"
                        onChange={onChangeHandler}
                        className={errors.emailErr && "input-error"}
                    />
                    <div
                        className="error"
                        style={{
                            display: errors.emailErr ? "block" : "none",
                        }}
                    >
                        {errors.emailErr}
                    </div>
                </Form.Group>
                <Form.Group></Form.Group>

                <div className="btn-group">
                    <button onClick={sendData} className=" blue loader-bt">
                        {spLoader ? (
                            <Spinner animation="border" role="status" size="sm">
                                <span className="visually-hidden"></span>
                            </Spinner>
                        ) : (
                            <>
                                {t(
                                    "UserPanel.Profile.PersonalInfo.SaveChanges.Button"
                                )}
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
}
